import { apiUrl } from '../utils/api-url';

export interface MethodologyDocument {
  id?: string;
  customerId: string;
  projectId: string;
  templateId: string;
  title: string;
  cafPhase: string;
  status: string;
  version: string;
  markdownContent: string;
  /**
   * Microsoft Specialisation Audit (V1.9.1) controls this document attests evidence for.
   * Populated from the source template's auditControls YAML frontmatter at scaffold time.
   * Null/undefined or empty = no controls tagged on this document.
   */
  auditControls?: string[] | null;
  /**
   * Migrate-run artifacts the rendered content consumed (RFC §4.6 / PR 7) — stamped at
   * scaffold/regenerate time. Drives the flag-for-regeneration banner: a newer imported run
   * than the recorded runNumber means the document shows stale assessment data.
   * Null/undefined = pre-PR-7 render or no artifacts consumed → no banner.
   */
  consumedArtifacts?: ConsumedArtifactRef[] | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ConsumedArtifactRef {
  artifactId: string;
  artifactType: string;
  runId?: string | null;
  runNumber?: number | null;
  generatedAt?: string | null;
}

export async function listDocuments(customerId: string, projectId: string, token: string): Promise<MethodologyDocument[]> {
  const res = await fetch(apiUrl(`/api/documents?customerId=${encodeURIComponent(customerId)}&projectId=${encodeURIComponent(projectId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to list documents: ${res.status}`);
  return res.json();
}

export async function getDocument(id: string, customerId: string, token: string): Promise<MethodologyDocument> {
  const res = await fetch(apiUrl(`/api/documents/${id}?customerId=${encodeURIComponent(customerId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to get document: ${res.status}`);
  return res.json();
}

export async function updateDocumentStatus(
  id: string, customerId: string, status: string, token: string, force = false,
): Promise<{ id: string; title: string; status: string }> {
  const res = await fetch(apiUrl(`/api/documents/${id}/status?customerId=${encodeURIComponent(customerId)}`), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ status, force }),
  });
  if (!res.ok) throw new Error(`Failed to update status: ${res.status}`);
  return res.json();
}
